// APIのベースURL
export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL;
// export const BASE_API_URL = "https://al2dx6uaed.execute-api.ap-northeast-1.amazonaws.com/soh_dev";
// export const BASE_API_URL = "http://localhost:9000/api";

// 機能ごとのエンドポイント
export const API_ENDPOINT = {
  USERS: "/users",
  HEALTH_METRICS_LIST: "/healthMetrics/lists",
  HEALTH_METRICS_INSERT: "/healthMetrics",
  HEALTH_METRICS_DELETE: "/healthMetrics/delete",
  HEALTH_METRICS_UPDATE: "/healthMetrics",
  HOSPITALS_LIST: "/hospitals/{facilityType}/list",
  CONSULTATION_LIST: "/consultation/list",
  CONSULTATION_INSERT: "/consultation",
  CONSULTATION_UPDATE: "/consultation",
  HEALTH_CHECK_LIST: "/healthcheck",
  HEALTH_CHECK_ITEM_LIST: "/healthCheck/item/list",
  HEALTH_CHECK_RESULT_LIST: "/healthCheck/result/list",
  HEALTH_CHECK_RESULT_INSERT: "/healthCheck/result/regist",
  HEALTH_CHECK_RESULT_UPDATE: "/healthCheck/result/update",
  HEALTH_CHECK_RESULT_DELETE: "/healthCheck/result/delete",
  /*
課題・障害番号: Todo 121行目
対応日: 2026/3/17
担当者: 藤原
修正概要: 健診年度の登録処理が漏れていたため、追加
*/
  USER_HEALTH_CHECK: "/user/healthcheck/updateHealthCheck",
  /*
END
課題・障害番号: Todo 121行目
*/
  USER_LIST: "/user/list",
  ADMIN: "/admin",
  /*
課題・障害番号: IH-BUG-36
対応日: 2026/03/26
担当者: ユリヤ
修正概要: 従業員の詳細検索がまだない問題の修正
*/
  USER_DETAIL_SEARCH: "/user/list?detailedSearch=true",
  /*
END
課題・障害番号: IH-BUG-36
*/
  USER_DATA_SHARING: "/user/data-sharing",
  USER_INSERT: "/user/regist",
  USER_UPDATE: "/user/update",
  USER_DELETE: "/user/delete",
  USER_AI_UPDATE: "/user/ai",
  TAG: "/tag/lookup",
  TAG_LIST: "/tag/list",
  TAG_INSERT: "/tag/insert",
  TAG_USER_INSERT: "/tag/user/insert",
  TAG_USER_DELETE: "/tag/user/delete",
  TASK_LIST: "/task/list",
  TASK_PROGRESS: "/task/task-progress",
  TASK_PROGRESS_LIST: "/task/task-progress/list",
  TASK_DETAIL: "/task/detail",
  TASK_INSERT: "/task/regist",
  TASK_DELETE: "/task/delete",
  TASK_UPDATE: "/task/update",
  TASK_REMINDER: "/task/reminder",
  TASK_TAG_INSERT: "/task/tag/regist",
  TASK_TAG_SELECT: "/task/tag/lookup",
  TASK_USER_INSERT: "/task/user/regist",
  TASK_USER_LIST: "/task/user/list",
  TASK_USER_UPDATE: "/task/user/update",

  /*
  課題・障害番号: IH-BUG-203
  対応日: 2026/03/29
  担当者: 檜垣
  修正概要: 管理者メッセージ通知メール送信用APIエンドポイントを追加
  */
  TASK_MESSAGE_TO_USER: "/notification/message-to-use",
  /*
  END
  課題・障害番号: IH-BUG-203
  */
  /*
課題・障害番号: IH-BUG-181
対応日: 2026/03/21
担当者: 藤原
修正概要: ステータスは配信時に変更するため、ここでは変更しないように修正。
*/
  TASK_START: "/taskStart",
  /*
END
課題・障害番号: IH-BUG-181
*/
  GENERAL_LIST: "/general/lists",
  SURVEY_LIST: "/survey/list",
  HEALTH_CHECK_YEAR_LIST: "/healthCheckYear/list",
  HEALTH_CHECK_YEAR_INSERT: "/healthCheckYear/insert",
  HEALTH_CHECK_YEAR_USER_DELETE: "/healthCheckYear/delete",
  AFFILIATION_LIST: "/affiliations/list",
  DEPARTMENT_LIST: "/departments/list",
  HOSPITAL_LIST: "/hospital/list",
  /*
課題・障害番号: IH-BUG-82
対応日: 2026/3/24
担当者: 小林
修正概要: 自組織分の情報のみ取得するように修正
*/
  HOSPITAL_DATA: "/hospital/readone",
  /*
END
課題・障害番号: IH-BUG-82
*/

  /*
課題・障害番号: KOSHO-166
対応日: 2026/04/02
担当者: 檜垣
修正概要: 登録代表者メール変更時の Cognito 検証コード入力モーダル
*/
  COMPANY_READONE: "/company/readone",
  COMPANY_DELETE: "/company/delete",
  COMPANY: "/company",
  KENPO_READONE: "/kenpo/readone",
  KENPO_DELETE: "/kenpo/delete",
  KENPO: "/kenpo",
  HOSPITAL_READONE: "/hospital/readone",
  HOSPITAL_DELETE: "/hospital/delete",
  HOSPITAL: "/hospital",
  GET_BY_IDENTIFICATION_CODE: "/{type}/get-by-identification-code",
  ADMIN_REGIST: "/admin/regist",
};
/*
END
課題・障害番号: KOSHO-166
*/
